import { render, staticRenderFns } from "./LimitEditor.vue?vue&type=template&id=3ff3497a&"
import script from "./LimitEditor.vue?vue&type=script&lang=js&"
export * from "./LimitEditor.vue?vue&type=script&lang=js&"
import style0 from "./LimitEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports